import { ThemeProvider } from '@user-portal/wikr-components';
import React, { ReactNode } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import GlobalStyle from './global-styles';
import { getCustomProperties } from './helpers';
import themeConfig from './themeConfig';

interface ThemeProviderProps {
    children: ReactNode;
}

const { theme, inline } = themeConfig;

const Provider = ({ children }: ThemeProviderProps) => {
    return (
        <StyledThemeProvider theme={theme}>
            <ThemeProvider theme={theme}>
                <GlobalStyle rootVariables={getCustomProperties(inline)} theme={theme} />
                {children}
            </ThemeProvider>
        </StyledThemeProvider>
    );
};

export default Provider;
